import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "summary",
  "use": "summary-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"summary\"><path class=\"cls-1\" d=\"M200 307.73A107.73 107.73 0 1 1 307.73 200 107.85 107.85 0 0 1 200 307.73zm0-202.46A94.73 94.73 0 1 0 294.73 200 94.84 94.84 0 0 0 200 105.27z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol